import { Http, Response } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/throw';

import { ApiError } from '../../services/action-updater.service';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';

export function handleError(error: Response | any): Array<string> | ErrorObservable {
    // In a real world app, you might use a remote logging infrastructure
    let consoleErrorMsg: string;
    let errSummary: string;
    let errMessage: string;
    let errDetails: Array<string> = null;
    let rawJsonErr: string;

    const getErrorDetails = (body: ApiErrorResponse): Array<string> => {
        if (body.Errors && body.Errors.length > 0) {
            return body.Errors.map(i => i.Value);
        } else {
            return body.MessageDetail ? [body.MessageDetail] : [];
        }
    };

    if (error instanceof Response) {
        try {
            const body: ApiErrorResponse = error.json() || '';
            errSummary = body.ErrorSummary || body.Message;
            errMessage = body.Message;
            errDetails = getErrorDetails(body);
            rawJsonErr = JSON.stringify(body);
        } catch (jsonSerialisationError) {
            errSummary = 'Error serialising response to json may be html';
        }
        consoleErrorMsg = `${error.status} - ${error.statusText || ''} ${rawJsonErr}`;
    } else {
        consoleErrorMsg = error.message ? error.message : error.toString();
    }
    console.error(consoleErrorMsg);

    const processedApiError = new ApiError(errSummary, errDetails, errMessage);
    return Observable.throw(processedApiError);
}

export class ApiErrorResponse {
    ErrorSummary: string;
    Message: string;
    MessageDetail: string;
    Errors: Array<ApiErrorDetails>;
}

export class ApiErrorDetails {
    Key: string;
    Value: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/components/error-summary/error-handler.function.ts